import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, CampaignLevelDTO, CompanyDTO } from '../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../services/util.service';
import { ModalService } from '../../../services/gui/modal/modal.service';
import { CompanyLevelEditComponent } from '../company-level-edit/company-level-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-company-level',
  templateUrl: './company-level.component.html',
  styleUrls: ['./company-level.component.scss'],
  standalone: false,
})
export class CompanyLevelComponent implements OnInit {
  debounceTimer: ReturnType<typeof setTimeout>;

  loading: boolean;

  companyId: number;
  company: CompanyDTO;
  levels: CampaignLevelDTO[];

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    private modalService: ModalService,
    private translate: TranslateService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.companyId = null;
    this.company = null;
    this.levels = [];
    this.loading = true;
    this.debounceTimer = null;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.companyId = params.companyID;
      if (this.companyId) {
        this.api
          .shared_Company_retrieveCompanyById(this.companyId)
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            take(1),
            finalize(() => {
              this.requestDebounced();
            })
          )
          .subscribe({
            next: (data: CompanyDTO) => {
              this.company = data;
            },
            error: () => {
              this.loading = false;
            },
          });
      } else {
        this.loading = false;
      }
    });
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.api
      .ds_cm_Campaign_retrieveLevels(this.companyId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (data: CampaignLevelDTO[]) => {
          this.levels = data;
        },
        error: () => {},
      });
  }

  showEditLevel(pLevel: CampaignLevelDTO) {
    if (!pLevel) {
      pLevel = new CampaignLevelDTO();
      pLevel.id = {};
    }
    this.modalService
      .showNavigationModal({
        entryComponent: {
          value: CompanyLevelEditComponent,
          data: { level: pLevel, companyData: this.company, levelOptions: this.levels },
        },
        title: this.translate.instant('lang.companyLevel.createLevel'),
        modalOptions: { size: 'lg' },
      })
      .then(() => {
        this.requestDebounced();
      })
      .catch(() => {});
  }
}
